export interface IProject {
  id?: string;
  name?: string;
  odooId?: number;
  initDate?: Date;
  endDate?: Date | null;
  clientEmail?: string;
  companyCif?: string;
  landingUrl?: string | null;
  members?: string[];
}

export class Project implements IProject {
  id?: string;
  name?: string;
  odooId?: number;
  initDate?: Date;
  endDate?: Date | null;
  clientEmail?: string;
  companyCif?: string;
  landingUrl?: string | null;
  members?: string[];

  constructor(data: IProject) {
    this.id = data?.id;
    this.name = data?.name;
    this.odooId = data?.odooId;
    this.initDate = data?.initDate;
    this.endDate = data?.endDate;
    this.clientEmail = data?.clientEmail;
    this.companyCif = data?.companyCif;
    this.landingUrl = data?.landingUrl;
    this.members = data?.members;
  }

  static empty = (): Project => {
    return new Project({
      id: null,
      name: null,
      odooId: null,
      initDate: null,
      endDate: null,
      clientEmail: null,
      companyCif: null,
      landingUrl: null,
      members: []
    });
  };
}

export class Projects extends Array<Project> {
  constructor(data: Project[]) {
    super(...data);
  }

  static empty = () => {
    return new Projects([]);
  };

  static from = (data: Project[]): Projects => {
    return new Projects(data.map(project => new Project(project)));
  };

  static fromI = (data: IProject[]): Projects => {
    return new Projects(data.map(project => new Project(project)));
  };

  getById = (id: string): Project | undefined => {
    return this.find(project => project.id === id);
  };

  getFilterByIds = (ids: string[]): Projects => {
    return new Projects(this.filter(project => !ids.includes(project.id)));
  };

  getFilterById = (id: string): Projects => {
    return new Projects(this.filter(project => project.id !== id));
  };
}
